import React from 'react';

const ModalContentMSP = React.createClass({
    render() {
        return (
            <div>
                <p>To ensure that you&rsquo;re covered for theft or attempted theft on your policy please check that your property meets our minimum standards of security, which are briefly summarised below:</p>
                <ul>
                    <li>the front and final exit doors of the property must be fitted with a lock conforming to BS3621 (look for the British Standards Institution Kitemark)</li>
                    <li>all other external doors should also have deadlocks or be fitted top and bottom with key operated security bolts</li>
                    <li>all accessible windows, fanlights and skylights, that can be opened must be secured with window locks with detachable keys.</li>
                </ul>
                <p>Your policy documentation will clearly outline our minimum standards of security for you.<br />
                    If you have any queries about this, please call us on 0800 038 4574.
                </p>
            </div>
        );
    }
});

export default ModalContentMSP;


/** WEBPACK FOOTER **
 ** ./src/components/Modals/Content/ModalContentMSP.js
 **/